import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.g46_1 = line;
        this.h46_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.g46_1 + ', column = ' + this.h46_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.i46_1 = message;
        this.j46_1 = locations;
        this.k46_1 = path;
        this.l46_1 = extensions;
        this.m46_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.i46_1 + ', locations = ' + toString(this.j46_1) + ', path=' + toString(this.k46_1) + ', extensions = ' + toString(this.l46_1) + ', nonStandardFields = ' + toString(this.m46_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Location as Location25t453jk43ktl,
  Error_0 as Error3q6zoyx198bpg,
};
//endregion

//# sourceMappingURL=Error.mjs.map
